export const isCapsLockPressed = (event: React.KeyboardEvent<HTMLInputElement>) => event.getModifierState('CapsLock');



// WEBPACK FOOTER //
// ./src/util/capslock.check.util.tsx